<template>
  <section class="sc-dashboard">
    <div class="container flex-wrapper">
      <main class="main-content layout-calc">
        <h2 class="tariff-title">{{ $t('myTvPassword') }}</h2>
        <div class="form-content">
          <div class="form-group password-field">
              <label class="form-check-label" for="password">
                  {{ $t('pages.administration.tab5.password') }}
              </label>
              <div class="password-input-wrapper">
                  <input class="form-control"
                        :type="showPassword ? 'text' : 'password'"
                        id="password"
                        name="password"
                        v-model="password"
                        @blur="passwordTouched = true"
                  >
                  <button type="button"
                          class="password-toggle-btn"
                          @click="togglePasswordVisibility"
                          :title="showPassword ? 'Sakrij lozinku' : 'Prikaži lozinku'">
                      <!-- Eye Open Icon (when password is visible) -->
                      <svg v-if="showPassword" class="password-toggle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                      </svg>
                      <!-- Eye Closed Icon (when password is hidden) -->
                      <svg v-else class="password-toggle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
                      </svg>
                  </button>
              </div>
          </div>
          <div v-if="showPasswordError" class="form-group">
              <p class="password-validation-error">{{ $t('messages.movePasswordValidation') }}</p>
          </div>
          <div class="form-group password-field">
              <label class="form-check-label" for="password2">
                  {{ $t('pages.administration.tab5.password2') }}
              </label>
              <div class="password-input-wrapper">
                  <input class="form-control"
                        :type="showPassword2 ? 'text' : 'password'"
                        id="password2"
                        name="password2"
                        v-model="password2"
                  >
                  <button type="button"
                          class="password-toggle-btn"
                          @click="togglePassword2Visibility"
                          :title="showPassword2 ? 'Sakrij lozinku' : 'Prikaži lozinku'">
                      <!-- Eye Open Icon (when password is visible) -->
                      <svg v-if="showPassword2" class="password-toggle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                      </svg>
                      <!-- Eye Closed Icon (when password is hidden) -->
                      <svg v-else class="password-toggle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
                      </svg>
                  </button>
              </div>
          </div>
          <div class="form-group">
              <button class="red-button" @click="submitChangeTvPassword" :disabled="!isPasswordValid">
                  {{ $t('pages.administration.tab5.button') }}
              </button>
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

<script>
import TvPassword from './TvPassword';
export default TvPassword;
</script>

<style scoped>
.password-field .password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-field .password-input-wrapper input {
  flex: 1;
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.password-toggle-btn:hover {
  opacity: 0.7;
}

.password-toggle-icon {
  width: 18px;
  height: 18px;
  color: #666;
  user-select: none;
}

.password-validation-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 4px;
  margin-bottom: 0;
}

.red-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
